import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux'; // 1. Redux hooks
import { List } from 'antd';
import { pushData } from '../utilities/pushData'; // 2. New Action Creator
import ProjectBrief from './ProjectBrief';

export default function Projects() {
  const dispatch = useDispatch();

  // 3. Select specific state slices
  const projects = useSelector(state => state.projects);
  const inspectorId = useSelector(state => state.inspector?.id);
  const selectedProjectId = useSelector(state => state.project?.id);

  // 4. Create the push helper (pass this to children if they need to dispatch updates)
  const push = (payload) => dispatch(pushData(payload));

  const filteredProjects = useMemo(() => {
    // Safety check if projects is empty/null
    const projectsList = projects ? Object.values(projects) : [];

    if (!inspectorId) return projectsList;

    console.log('Filtering projects for inspector id:', inspectorId);
    
    return projectsList.filter(project => {
      if (project.inspection?.inspector?.id && project.inspection.inspector.id === inspectorId) {
        return true;
      }
      return false;
    });
  }, [projects, inspectorId]);

  return (
    <div className="full-height full-width">
      <List
        style={{ height: '70rem', overflow: 'scroll', paddingBottom: '2rem', marginBottom: '.5rem', paddingRight: '1rem' }}
        dataSource={filteredProjects}
        loading={!projects} // Simple check if projects exist
        pagination={{
          pageSize: 20,
          showSizeChanger: false,
          showQuickJumper: false,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} projects`,
        }}
        renderItem={(project) => (
          <ProjectBrief 
            id={selectedProjectId} 
            push={push} 
            project={project} 
          />
        )}
      />
    </div>
  );
}